<template>
  <el-upload
    :auto-upload="false"
    :file-list="fileList"
    :limit="1"
    :accept="accept"
    :show-file-list="false"
    action="javascript:void(0)"
    :on-change="changeFile"
  >
    <el-button v-if="uploadBtnShow||uploadBtnShow==''" :type="btnType" :size="btnSize" :style="{'color': color}">{{text}}</el-button>
  </el-upload>
</template>
<script>
import http from "@/util/http";
export default {
  name: "imgFile",
  data() {
    return {
      fileName: "",
      fileList: []
    };
  },
  props: {
    value: {
      type: Object | String
    },
    type: {
      type: Number
    },
    limit: {
      type: Number,
      default: 20
    },
    accept: {
      type: String
    },
    uploadBtnShow: {
      type: Boolean | String,
      default: true
    },
    text: {
      type: String,
      default: "点击上传"
    },
    action: {
      type: String,
      default: "/share-foreign/commannex/uploadAnnex"
    },
    btnType: {
      type: String,
      default:'text'
    },
    btnSize: {
      type: String,
      default: ''
    },
    color:  {
      type: String,
      default: "#409EFF"
    },
  },
  methods: {
    changeFile(file) {
      if (file.size > this.limit * 1024 * 1024) {
        this.$message({
          type: "error",
          message: "大小不能超过" + this.limit + "mb"
        });
        this.fileList.splice(0, 1);
        return;
      }
      if (file.name && this.accept) {
        let formatName = file.name.substring(file.name.lastIndexOf('.') + 1)
        //文件格式与期望的不匹配
        if (this.accept.includes(formatName) == false) {
          this.$message({
            type: 'error',
            message: '文件格式错误，请上传正确格式！'
          })
          this.fileList.splice(0, 1);
          return;
        }
      }
      this.uploadFile(file)
        .then(() => {
          this.fileList.splice(0, 1);
          this.$message.success("上传成功");
           // 添加上传完成事件
          this.$emit('upload-success', file);
        })
        .catch(e => {
          this.fileList.splice(0, 1);
          this.$message.error("上传失败");
        });
    },
    uploadFile(file) {
      return http
        .upload(this.action, { file: file.raw })
        .then(res => {
          if (typeof this.value === "string") {
               this.$emit("input", res.data);
          } else {
            this.$emit("input", {
              ...this.value,
              path: res.data,
              fileName: file.name
            });
          }
        });
    },
    setBase64(file) {
      let reader = new FileReader();
      reader.readAsDataURL(file.raw);
      reader.onload = () => {
        this.$emit("input", {
          fileContent: reader.result,
          fileName: file.name,
          type: this.type
        });
      };
    }
  }
};
</script>
